import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import SignupPageView from "views/signup/SignupPageView";
import FacebookHelper from "models/helper/FacebookHelper";
import AppleIDHelper from "models/helper/AppleIDHelper";
import FacebookEventTrackingHelper from "models/helper/FacebookEventTrackingHelper";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import SignupIntentHelper from "models/helper/SignupIntentHelper";
import { INLINE_AUTH_MODES } from "models/helper/InlineAuthModes";
import { syncBrowserUrlForCompletedSignup, completeSignupFlow } from "models/helper/SignupFlowHelper";
import Utils from "models/helper/Utils";
import ti18n from "i18n!nls/signupPagei18n";
import RSVP from "rsvp";

const SignupController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this.onSignupSuccessfullyCompleted =  options? options.onSignupSuccessfullyCompleted:null;
        this.signupApi =  options? options.signupApi:null;
        this.signupWithFacebookApi =  options? options.signupWithFacebookApi:null;
        this.signupWithGoogleApi =  options? options.signupWithGoogleApi:null;
        this.signupWithAppleApi =  options? options.signupWithAppleApi:null;
        this.startOrganizationLoginApi = options ? options.startOrganizationLoginApi : TrebbleClientAPIHelper.getInstance().startOrganizationLogin.bind(TrebbleClientAPIHelper.getInstance());
        this.signupAsShortcastCreator =  options ? options.signupAsShortcastCreator : false;
        this._accessCode = options? options.accessCode : null;
        this._defaultSignupIntent = options ? options.defaultSignupIntent : null;
        this._hideBackButton = options? options.hideBackButton : false;
        if(!this._accessCode && window.trebble.presetAccessCode){
            this._accessCode = window.trebble.presetAccessCode;
        }
        if(!this._defaultSignupIntent){
            this._defaultSignupIntent = this.signupAsShortcastCreator ? SignupIntentHelper.SIGNUP_INTENTS.SHORTCAST_CREATOR : SignupIntentHelper.getDefaultSignupIntentForCurrentSurface();
        }
        if(!this._accessCode){
            this._accessCode = SignupIntentHelper.normalizeSignupPayload({}, {
                defaultSignupIntent: this._defaultSignupIntent,
            }).accessCode;
        }
        this._forwardAfterSignup = options? options.forwardAfterSignup: false;
        this._loginForwardUrl = options? options.loginForwardUrl : null;
        this.isUserpreviouslyLoggedInAsGuest =  options? options.isUserpreviouslyLoggedInAsGuest:false;
        this._pendingInlineAuthChallenge = null;

    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    _getVerifyEmailVerificationApi : function(){
        return TrebbleClientAPIHelper.getInstance().verifyEmailVerification.bind(TrebbleClientAPIHelper.getInstance());
    },

    _promptForPendingEmailVerification : function(challenge){
        $.mobile.loading("hide");
        if(!this.view){
            return RSVP.Promise.reject(new Error("View unavailable for email verification"));
        }
        return new RSVP.Promise((function(resolve, reject){
            this._pendingInlineAuthChallenge = {
                mode: INLINE_AUTH_MODES.EMAIL_VERIFICATION,
                pendingAuthenticationToken: challenge ? challenge.pendingAuthenticationToken : null,
                resolve: resolve,
                reject: reject,
            };
            this.view.openInlineAuthFlow(INLINE_AUTH_MODES.EMAIL_VERIFICATION, {
                email: challenge && challenge.email ? challenge.email : "",
                pendingAuthenticationToken: challenge ? challenge.pendingAuthenticationToken : null,
            });
        }).bind(this));
    },

    validateEmail : function(email){
        return Utils.getInstance().getEmailRegexValidation().test(email ? email.trim().toLowerCase() : email);
    },

    startOrganizationLogin : function(email){
        const resolvedEmail = email ? email.trim().toLowerCase() : "";
        if(!this.validateEmail(resolvedEmail)){
            if(this.view){
                this.view.setInlineAuthError(window.getI18n(ti18n, "ORGANIZATION_SIGNUP_REQUIRES_WORK_EMAIL"));
            }
            return RSVP.Promise.resolve(false);
        }

        $.mobile.loading("show");
        return this.startOrganizationLoginApi(resolvedEmail).then((function(result){
            if(this.view){
                this.view.closeInlineAuthFlow();
            }
            return result;
        }).bind(this)).catch((function(error){
            if(this.view){
                const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
                this.view.setInlineAuthError(resolvedErrorMessage || window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
            }
        }).bind(this)).finally((function(){
            $.mobile.loading("hide");
        }).bind(this));
    },

    onOrganizationSignupBtnTapped : function(){
        const defaultEmail = this.view && this.view.emailField$el && this.view.emailField$el.is(":visible") && this.validateEmail(this.view.emailField$el.val()) ?
            this.view.emailField$el.val().trim().toLowerCase() :
            "";
        if(this.view){
            this.view.openInlineAuthFlow(INLINE_AUTH_MODES.SSO_EMAIL, {
                email: defaultEmail,
            });
        }
    },

    onInlineAuthSubmit : function(data){
        if(!data || !data.mode){
            return RSVP.Promise.resolve(false);
        }

        if(data.mode === INLINE_AUTH_MODES.SSO_EMAIL){
            return this.startOrganizationLogin(data.email);
        }

        if(data.mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            if(!data.code){
                if(this.view){
                    this.view.setInlineAuthError(window.getI18n(ti18n, "VERIFICATION_CODE_REQUIRED"));
                }
                return RSVP.Promise.resolve(false);
            }

            $.mobile.loading("show");
            return this._getVerifyEmailVerificationApi()(data.pendingAuthenticationToken, data.code).then((function(loginSuccessfull){
                if(loginSuccessfull){
                    syncBrowserUrlForCompletedSignup();
                    const pendingChallenge = this._pendingInlineAuthChallenge;
                    this._pendingInlineAuthChallenge = null;
                    if(this.view){
                        this.view.closeInlineAuthFlow();
                    }
                    if(pendingChallenge && pendingChallenge.resolve){
                        pendingChallenge.resolve(true);
                    }
                }else{
                    throw window.getI18n(ti18n, "VERIFY_EMAIL_FAILED");
                }
            }).bind(this)).catch((function(error){
                if(this.view){
                    const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
                    this.view.setInlineAuthError(resolvedErrorMessage || window.getI18n(ti18n, "VERIFY_EMAIL_FAILED"));
                }
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        return RSVP.Promise.resolve(false);
    },

    onInlineAuthSecondaryAction : function(data){
        if(data && data.mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            const pendingChallenge = this._pendingInlineAuthChallenge;
            this._pendingInlineAuthChallenge = null;
            if(this.view){
                this.view.closeInlineAuthFlow();
            }
            if(pendingChallenge && pendingChallenge.reject){
                pendingChallenge.reject("handled");
            }
            return;
        }

        if(this.view){
            this.view.closeInlineAuthFlow();
        }
    },

    _completeSignupFlow : function(signupResultData){
        return completeSignupFlow(signupResultData, this.onSignupSuccessfullyCompleted);
    },


    doSignup : function(data){
        $.mobile.loading("show");
        const normalizedSignupData = SignupIntentHelper.normalizeSignupPayload(data, {
            defaultSignupIntent: this._defaultSignupIntent,
        });
        FacebookEventTrackingHelper.getInstance().trackLeadWithIntentToSignup();
        this.signupApi(normalizedSignupData).then((function(operationResult){
            if(operationResult && operationResult.userCreated){
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
                }
                // Track user signup for SaaS tracking
                try {
                    FacebookEventTrackingHelper.getInstance().trackUserSignup('email');
                } catch(trackingError) {
                    console.warn('Failed to track user signup:', trackingError);
                }

                const requiresEmailVerification = !!operationResult.requiresEmailVerification;
                const initialSessionEstablished = !!(operationResult.token || operationResult.sessionTransport === "cookie");
                const afterVerificationPromise = requiresEmailVerification ? this._promptForPendingEmailVerification(operationResult) : RSVP.Promise.resolve(true);
                return afterVerificationPromise.then((function(){
                    // After successful email verification the backend issues a
                    // session even if the initial /signup response did not
                    // include a token/cookie. For signups that didn't require
                    // verification, fall back to the initial response's
                    // session-establishment signal; otherwise the login
                    // controller would skip doLogin and navigate without an
                    // actual session.
                    const sessionEstablished = requiresEmailVerification ? true : initialSessionEstablished;
                    return this._completeSignupFlow(Object.assign({}, normalizedSignupData, {
                        authenticatedSessionReady: sessionEstablished,
                    }));
                }).bind(this));
            }else{
                $.mobile.loading("hide");
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
                } 
                if(operationResult && operationResult.userAlreadyExist){
                    window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_USERNAME")+" '"+ normalizedSignupData.username  + "' "+ window.getI18n(ti18n, "ALREADY_EXISTS")+".");
                    return RSVP.reject("handled");
                }else{
                    if(operationResult && operationResult.emailAlreadyUsed){
                        window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL")+" '"+ normalizedSignupData.email  + "' "+ window.getI18n(ti18n, "ALREADY_EXISTS")+".");
                        return RSVP.reject("handled");
                    }
                }
                window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
                return RSVP.reject("handled");
            }
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            if(error === window.getI18n(ti18n, "INVALID_ACCESS_CODE")){
                this.showErrorMessageForAccessCode(window.getI18n(ti18n, "INVALID_ACCESS_CODE"));
            }else if(error !== "handled"){
                window.alertErrorMessage(error);
            }
        }).bind(this));
    },


    doLoginViaFacebookPopupWindow : function(){
        return FacebookHelper.getInstance().login();
        /*return new RSVP.Promise(function(resolve, reject){
            FB.login(function(response){
                if (response.status === 'connected') {
                    // Logged into your app and Facebook.
                    resolve(response.authResponse);
                } else {
                    // The person is not logged into this app or we are unable to tell.
                    resolve(null); 
                    //resolve({"accessToken":"EAAQekcVgZBPgBAOPHZCYG2aX6eC0VztgdGJIXWnab4DH3nItnBDZAwrMivPJHGeY2DLCgojxWX8kVdByG5GEi6dK7GzGJWaG5u9qqRZAw2S51OSU6yNH7j9kZBlKpYZCX7rZBYdT3vjdWaQQuUrAC41ZAPKfLFZASOZCxKtHl9sTX3VofUVFSKSRArXuC9tkAmq2QBecBwT7sN2gZDZD"});
                }
            }, {scope: 'public_profile,email'})
})*/
},


doSignupThroughFacebook : function(accessCode){
const normalizedSignupData = SignupIntentHelper.normalizeSignupPayload({
    accessCode: accessCode,
}, {
    defaultSignupIntent: this._defaultSignupIntent,
});
$.mobile.loading("show");
if(Utils.getInstance().isBrowserHostedAuthEnvironment() || window.waitForCordovaToLoad){
return this.signupWithFacebookApi(null, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null, null,null, null, null, null, null, normalizedSignupData.profileType || null).catch((function(error){
    window.alertUserErrorMessage(error);
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
}
let facebookAuthInfo = null;
FacebookEventTrackingHelper.getInstance().trackLeadWithIntentToSignup();
return this.doLoginViaFacebookPopupWindow().then((function(authInfo){
    facebookAuthInfo = authInfo;
    if(facebookAuthInfo){
        return this.signupWithFacebookApi(facebookAuthInfo.accessToken, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null, null,null, null, null, null, null, normalizedSignupData.profileType || null);
    }else{
        throw window.getI18n(ti18n, "PLEASE_LOGIN_FACEBOOK_TO_CREATE_ACCOUNT");
    }
}).bind(this)).then((function(operationResult){
    if(operationResult && (operationResult.userCreated || operationResult.tokenInfo || operationResult.userInfo)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
        } 
        // Track user signup for SaaS tracking
        try {
            FacebookEventTrackingHelper.getInstance().trackUserSignup('facebook');
        } catch(trackingError) {
            console.warn('Failed to track user signup:', trackingError);
        }
        return this._completeSignupFlow({"externalProfileSignup":"Facebook" ,"facebookAccessToken": facebookAuthInfo.accessToken});
    }else{
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
        } 
        if(operationResult && operationResult.userAlreadyExist){
            window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_FACEBOOK_ACCOUNT_ALREADY_EXISTS"));
            return RSVP.reject("handled");
        }else{
            if(operationResult && operationResult.emailAlreadyUsed){
                window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL_ALREADY_EXISTS"));
                return RSVP.reject("handled");
            }
        }
        window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
        return RSVP.reject("handled");
    }
}).bind(this)).catch((function(error){
    if(error !== "handled"){
        window.alertErrorMessage(error);
    }
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
},

doLoginViaApplePopupWindow : function(){
return AppleIDHelper.getInstance().login();			
},

doSignupThroughApple : function(accessCode){
const normalizedSignupData = SignupIntentHelper.normalizeSignupPayload({
    accessCode: accessCode,
}, {
    defaultSignupIntent: this._defaultSignupIntent,
});
$.mobile.loading("show");
if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
return this.signupWithAppleApi(null, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null,null, null, null, null, null, null, normalizedSignupData.profileType || null).catch((function(error){
    window.alertUserErrorMessage(error);
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
}
if(window.waitForCordovaToLoad){
return this.signupWithAppleApi(null, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null,null, null, null, null, null, null, normalizedSignupData.profileType || null).then((function(operationResult){
    if(operationResult && (operationResult.userCreated || operationResult.tokenInfo || operationResult.userInfo)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
        }
        try {
            FacebookEventTrackingHelper.getInstance().trackUserSignup('apple');
        } catch(trackingError) {
            console.warn('Failed to track user signup:', trackingError);
        }
        return this._completeSignupFlow(Object.assign({}, normalizedSignupData, {
            authenticatedSessionReady: true,
        }));
    }else{
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
        }
        if(operationResult && operationResult.userAlreadyExist){
            window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_APPLE_ACCOUNT_ALREADY_EXISTS"));
            return RSVP.reject("handled");
        }else{
            if(operationResult && operationResult.emailAlreadyUsed){
                window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL_ALREADY_EXISTS"));
                return RSVP.reject("handled");
            }
        }
        window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
        return RSVP.reject("handled");
    }
}).bind(this)).catch((function(error){
    if(error !== "handled"){
        window.alertErrorMessage(error);
    }
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
}
let appleAuthInfo = null;
FacebookEventTrackingHelper.getInstance().trackLeadWithIntentToSignup();
return this.doLoginViaApplePopupWindow().then((function(authInfo){
    appleAuthInfo = authInfo;
    if(appleAuthInfo){
        return this.signupWithAppleApi(appleAuthInfo.authorization.id_token, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null,null, null, null, null, null, null, normalizedSignupData.profileType || null);
    }else{
        throw window.getI18n(ti18n, "PLEASE_LOGIN_APPLE_TO_CREATE_ACCOUNT");
    }
}).bind(this)).then((function(operationResult){
    if(operationResult && (operationResult.userCreated || operationResult.tokenInfo || operationResult.userInfo)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
        } 
        // Track user signup for SaaS tracking
        try {
            FacebookEventTrackingHelper.getInstance().trackUserSignup('apple');
        } catch(trackingError) {
            console.warn('Failed to track user signup:', trackingError);
        }
        return this._completeSignupFlow({"externalProfileSignup":"Apple" ,"appleAccessToken": appleAuthInfo.authorization.id_token});
    }else{
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
        } 
        if(operationResult && operationResult.userAlreadyExist){
            window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_APPLE_ACCOUNT_ALREADY_EXISTS"));
            return RSVP.reject("handled");
        }else{
            if(operationResult && operationResult.emailAlreadyUsed){
                window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL_ALREADY_EXISTS"));
                return RSVP.reject("handled");
            }
        }
        window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
        return RSVP.reject("handled");
    }
}).bind(this)).catch((function(error){
    if(error !== "handled"){
        window.alertErrorMessage(error);
    }
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
},

doSignupThroughGoogle : function(googleUser, accessCode){
const normalizedSignupData = SignupIntentHelper.normalizeSignupPayload({
    accessCode: accessCode,
}, {
    defaultSignupIntent: this._defaultSignupIntent,
});
$.mobile.loading("show");
if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
return this.signupWithGoogleApi(googleUser && googleUser.getAuthResponse ? googleUser.getAuthResponse().id_token : null, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null, null,null, null, null, null, null, normalizedSignupData.profileType || null).catch((function(error){
    window.alertUserErrorMessage(error);
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
}
if(window.waitForCordovaToLoad){
return this.signupWithGoogleApi(googleUser && googleUser.getAuthResponse ? googleUser.getAuthResponse().id_token : null, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null, null,null, null, null, null, null, normalizedSignupData.profileType || null).then((function(operationResult){
    if(operationResult && (operationResult.userCreated || operationResult.tokenInfo || operationResult.userInfo)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
        }
        try {
            FacebookEventTrackingHelper.getInstance().trackUserSignup('google');
        } catch(trackingError) {
            console.warn('Failed to track user signup:', trackingError);
        }
        return this._completeSignupFlow(Object.assign({}, normalizedSignupData, {
            authenticatedSessionReady: true,
        }));
    }else{
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
        }
        if(operationResult && operationResult.userAlreadyExist){
            window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_GOOGLE_ACCOUNT_ALREADY_EXISTS"));
            return RSVP.reject("handled");
        }else{
            if(operationResult && operationResult.emailAlreadyUsed){
                window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL_ALREADY_EXISTS"));
                return RSVP.reject("handled");
            }
        }
        window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
        return RSVP.reject("handled");
    }
}).bind(this)).catch((function(error){
    if(error !== "handled"){
        window.alertErrorMessage(error);
    }
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
}
FacebookEventTrackingHelper.getInstance().trackLeadWithIntentToSignup();
return this.signupWithGoogleApi(googleUser.getAuthResponse().id_token, normalizedSignupData.accessCode, normalizedSignupData.context || null, null, null, null,null, null, null, null, null, normalizedSignupData.profileType || null).then((function(operationResult){
    if(operationResult && (operationResult.userCreated || operationResult.tokenInfo || operationResult.userInfo)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
        } 
        // Track user signup for SaaS tracking
        try {
            FacebookEventTrackingHelper.getInstance().trackUserSignup('google');
        } catch(trackingError) {
            console.warn('Failed to track user signup:', trackingError);
        }
        return this._completeSignupFlow({"externalProfileSignup":"Google" ,"googleAccessToken": googleUser.getAuthResponse().id_token, "googleUser": googleUser});
    }else{
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed");
        } 
        if(operationResult && operationResult.userAlreadyExist){
            window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_GOOGLE_ACCOUNT_ALREADY_EXISTS"));
            return RSVP.reject("handled");
        }else{
            if(operationResult && operationResult.emailAlreadyUsed){
                window.alertUserErrorMessage(window.getI18n(ti18n, "USER_WITH_EMAIL_ALREADY_EXISTS"));
                return RSVP.reject("handled");
            }
        }
        window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_NEW_ACCOUNT"));
        return RSVP.reject("handled");
    }
}).bind(this)).catch((function(error){
    if(error !== "handled"){
        window.alertErrorMessage(error);
    }
}).bind(this)).finally((function(){ $.mobile.loading("hide"); }).bind(this));
},

onGoogleLoginFailed :function(error){
window.alertErrorMessage(window.getI18n(ti18n, "PLEASE_LOGIN_GOOGLE_TO_CREATE_ACCOUNT"));
},

showErrorMessageForAccessCode : function(errorMessage){
const buttonLabels =  [window.getI18n(ti18n, "OK"), window.getI18n(ti18n, "REQUEST_ONE")];
const confirmCallback = (function(buttonIndex){
if(buttonIndex ==  2){
    this.openRequesInvitePage();
}
}).bind(this);
window.window.showConfirmDialog(errorMessage, confirmCallback,  null,buttonLabels, null, "error");
},

onViewRemovedFromDocument : function(){
if(this.onSignupSuccessfullyCompleted){
this.onSignupSuccessfullyCompleted(false);
}
},

openRequesInvitePage : function(){
const openedWindow = window.open("https://trebble.typeform.com/to/JXo8tX", "_blank");
if((!openedWindow || openedWindow.closed || typeof openedWindow.closed=='undefined') && !window.waitForCordovaToLoad){
window.alertErrorMessage(window.getI18n(ti18n, "PLEASE_ALLOW_POPUPS_FOR_TREBBLE"));
}else{
if(openedWindow.focus){
    openedWindow.focus();
}
}

},

onViewRemoved:function(){
this.stopListening();
},

buildModelAndRenderView : function() {
return new RSVP.Promise((function(resolve, reject) {
try {
    const options = {};
    options.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
    options.accessCode = this._accessCode;
    options.defaultSignupIntent = this._defaultSignupIntent;
    options.hideBackButton  = this._hideBackButton;
    options.loginForwardUrl = this._loginForwardUrl;
    const hasCordovaBootstrap = typeof window !== "undefined" && window.waitForCordovaToLoad;
    options.showOrganizationLogin = Utils.getInstance().isBrowserHostedAuthEnvironment() || hasCordovaBootstrap;
    this.view = new SignupPageView(options);
    this.view.render();

		this.listenTo(this.view, "signUpBtnTapped", this.doSignup);
		this.listenTo(this.view, "signUpWithFacebookBtnTapped", this.doSignupThroughFacebook);
		this.listenTo(this.view, "signUpWithAppleBtnTapped", this.doSignupThroughApple);
		this.listenTo(this.view, "signUpWithGoogleBtnSuccess", this.doSignupThroughGoogle);
		this.listenTo(this.view, "signUpWithGoogleBtnFailed",this.onGoogleLoginFailed);
		this.listenTo(this.view, "signUpWithOrganizationBtnTapped", this.onOrganizationSignupBtnTapped);
		this.listenTo(this.view, "signupInlineAuthSubmit", this.onInlineAuthSubmit);
		this.listenTo(this.view, "signupInlineAuthSecondaryAction", this.onInlineAuthSecondaryAction);
		this.listenTo(this.view, "removedFromPage", this.onViewRemovedFromDocument);
		this.listenTo(this.view, "remove", this.onViewRemoved.bind(this));

    resolve();
    if(window.trebbleAnalyticsHelper){
        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupPageOpened", "Sign-up Page Opened");
    } 
} catch (error) {
    reject(error);
}

}).bind(this));

}

});

export default SignupController;
